<tlk-card [padding]="0" class="rx-intuitive-teeth-diagram">
	<ng-container *ngIf="injectedSpritesContent$ | async as injectedSpritesContent">
		<div
			class="teeth-sprites"
			aria-hidden="true"
			*ngFor="let sprite of injectedSpritesContent | keyvalue; trackBy: trackByMapKey"
			[innerHTML]="sprite.value"
		></div>
	</ng-container>
	<div tlkCardContent class="rx-intuitive-teeth-diagram__content">
		<div class="rx-intuitive-teeth-diagram__diagram-section">
			<ng-content select="[rx-intuitive-teeth-diagram-banner]"></ng-content>
			<div class="rx-intuitive-teeth-diagram__chart-editing-cluster">
				<ng-content select="[rx-intuitive-teeth-diagram-toolbar]"></ng-content>
				<ng-content select="[rx-intuitive-teeth-diagram-diagram]"></ng-content>
				<ng-content select="[rx-intuitive-teeth-diagram-buttons]"></ng-content>
			</div>
		</div>
		<hr class="rx-intuitive-teeth-diagram__separator" />
		<div class="rx-intuitive-teeth-diagram__sidebar">
			<ng-content select="[rx-intuitive-teeth-diagram-panel]"></ng-content>
		</div>
	</div>
	<div tlkCardFooter class="rx-intuitive-teeth-diagram__footer">
		<ng-content select="[rx-intuitive-teeth-diagram-footer]"></ng-content>
	</div>
</tlk-card>
